import '../css/admin.css';

Vue.component('boffo-list-view', {
  template: '#boffo-list-template',
  data: function () {
    return {
      forms: []
    }
  },
  methods: {
    init() {
      var self = this;

      var data = {
        action: 'get_boffo_admin_forms'
      };

      jQuery.ajax({
        url: ajaxurl,
        method: 'POST',
        data: data,
        success: function (data) {
          self.forms = self.unescapeObj(data);
        },
        error: function (error) {
          console.log('error', error);
        }
      });
    },
    addForm() {
      this.$emit('edit-form', {
        title: '',
        delivery_method: 'email',
        submit_button_text: 'Send',
        confirmation_message: 'Thanks for connecting with us!',
        items: []
      });
    },
    editForm(form) {
      this.$emit('edit-form', form);
    },
    deleteForm(form, index) {
      var self = this;

      var data = {
        action: 'delete_boffo_admin_form',
        form: form
      };

      jQuery.ajax({
        url: ajaxurl,
        method: 'POST',
        data: data,
        success: function (data) {
          self.init();

          jQuery('#boffo-views .toast').html('Successfully removed!').addClass('on');

          setTimeout(function () {
            jQuery('#boffo-views .toast').removeClass('on');
          }, 4000);
        },
        error: function (error) {
          console.log('error', error);
        }
      });
    },
    unescapeObj(obj) {
      var j = JSON.stringify(obj);

      j = j.split('\\').join('');

      return JSON.parse(j);
    }
  },
  mounted: function () {
    this.init();
  }
});

Vue.component('boffo-detail-view', {
  template: '#boffo-detail-template',
  data: function () {
    return {
      activeItem: 0
    }
  },
  props: ['form'],
  methods: {
    addItem() {
      this.form.items.push({ text: '', value: '', type: 'text', options: [{ text: '' }] });
      this.activeItem = this.form.items.length - 1;
      this.setItemTextFocus(this.activeItem);
    },
    deleteItem(index) {
      this.activeItem = (this.activeItem - 1) < 0 ? 0 : (this.activeItem - 1);
      this.form.items.splice(index, 1);
    },
    addOption(item) {
      if (item.options == undefined) item.options = [];

      item.options.push({ text: '' });
    },
    deleteOption(item, index) {
      item.options.splice(index, 1);
    },
    editItem(index) {
      this.activeItem = index;
      this.setItemTextFocus(index);
    },
    save(form) {
      if (!this.isFormValid(form)) return;

      var data = {
        action: 'post_boffo_admin_form',
        form: form
      };

      jQuery.ajax({
        url: ajaxurl,
        method: 'POST',
        data: data,
        success: function (data) {
          jQuery('#boffo-views .toast').html('Flow successfully saved!').removeClass('error').addClass('on');

          setTimeout(function () {
            jQuery('#boffo-views .toast').removeClass('on');
          }, 4000);
        },
        error: function (error) {
          
        }
      });
    },
    cancel() {
      this.$emit('cancel');
    },
    isFormValid(form) {
      if (form.title.length < 1) {
        this.showToast('Please add a title.', true);

        return false;
      }

      if (form.submit_button_text.length < 1) {
        this.showToast('Please add a submit button.', true);

        return false;
      }

      if (form.confirmation_message.length < 1) {
        this.showToast('Please add a confirmaton message.', true);

        return false;
      }

      if (form.items.length < 1) {
        this.showToast('Please add steps.', true);

        return false;
      }

      for (var i = 0; i < form.items.length; i++) {
        if (form.items[i].text.length < 1) {
          this.showToast('Please make sure your steps have lead-in copy.', true);

          return false;
        }
      }

      return true;
    },
    setItemTextFocus(index) {
      var vm = this;

      Vue.nextTick(function () {
        if (vm.form.items.length < 1) {
          vm.$refs['titleInput'].focus();
        } else {
          vm.$refs['itemTextInput'][index].focus();
        }
      });
    },
    showToast(message, isError) {
      var toast = jQuery('#boffo-views .toast');

      toast.html(message).removeClass('error').addClass('on');

      if (isError) toast.addClass('error');

      setTimeout(function () {
        toast.removeClass('on');
      }, 4000);
    }
  },
  mounted: function () {
  },
  watch: {
    form: function (newVal, oldVal) {
      this.activeItem = 0;
      this.setItemTextFocus(0);
    }
  }
});

var boffoViews = new Vue({
  el: '#boffo-views',
  data: function () {
    return {
      currentForm: {},
      currentView: 'listView'
    }
  },
  methods: {
    addForm() {
      this.currentForm = {
        title: '',
        delivery_method: 'email',
        submit_button_text: 'Send',
        confirmation_message: 'Thanks for connecting with us!',
        items: []
      };
      this.currentView = 'detailView';
    },
    loadFormDetails(form) {
      this.currentForm = form;
      this.currentView = 'detailView';
    },
    showListView() {
      this.currentForm = {
        title: '',
        items: []
      };
      this.currentView = 'listView';

      this.$refs.listView.init()
    }
  }
});


// WEBPACK FOOTER //
// ./js/admin.js